import React from 'react';
import { personalInfo } from '../data/data';



const Footer = () => {
   

  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ padding: "40px", textAlign: "center", borderTop: "1px solid #444", marginTop: "50px" }}>
      
      <h2>
        <span style={{ color: "cyan" }}>SIM</span>LAI
      </h2>

      <p style={{ marginTop: "10px" }}>
        © {currentYear} {personalInfo.name}. All rights reserved.
      </p>

      <div style={{ marginTop: "20px" }}>
        <a href={personalInfo.linkedin} target="_blank" rel="noreferrer">
          LinkedIn
        </a>

        <span style={{ margin: "0 10px" }}></span>

        <a href={`mailto:${personalInfo.email}`}>
          Email
        </a>
      </div>

      <p style={{ marginTop: "20px" }}>
        Building the Future with AI
      </p>

    </footer>
  );
};

export default Footer;